import { documentService, windowService } from './window.utils';

const handleScrollUp = (elementDim: DOMRect, elementSticky: HTMLElement, stickyWrapperHeight: number, header: HTMLElement) => {
  if (elementDim.top > stickyWrapperHeight - elementDim.height) {
    if (elementDim.top < 1) return;
    elementSticky?.classList.add('sticky-element--hide');
    header?.classList.remove('sticky-element--hide');
    header?.setAttribute('style', 'display: block');
  } else {
    if (documentService().querySelector('body').classList.contains('scrolling')) {
      header?.setAttribute('style', 'display: none');
    }
  }
};

const handleScrollDown = (elementDim: DOMRect, elementSticky: HTMLElement, stickyWrapperHeight: number, header: HTMLElement) => {
  let elementStickyVisible = false;
  if (elementSticky) {
    elementStickyVisible = !elementSticky.classList.contains('sticky-element--hide');
  }
  let thresholdTop = stickyWrapperHeight;
  if (elementStickyVisible) {
    thresholdTop -= elementDim.height;
  }
  if (elementDim.top > thresholdTop) {
    elementSticky?.classList.add('sticky-element--hide');
    header?.classList.remove('sticky-element--hide');
    if (windowService().scrollY < 1) return;
    header?.classList.add('navigation--hide');
  } else {
    if (elementDim.bottom < thresholdTop) {
      header?.classList.add('sticky-element--hide');
    }
    if (elementDim.top <= thresholdTop) {
      elementSticky?.classList.remove('sticky-element--hide');
    } else {
      elementSticky?.classList.add('sticky-element--hide');
    }
  }
};

const detectScrollDirectionForNavigationBar = (stickyWrapperEle: HTMLElement | null, scrollPosition: number) => {
  const header = documentService()?.querySelector?.('#root > header > .header > #sticky-top-wrapper > .navigation') as HTMLElement;
  const bodyScrollPosition = documentService().body.getBoundingClientRect().top;
  const element =
    (documentService()?.querySelector?.('#root > main > .navigation-bar-mobile') as HTMLElement) ||
    (documentService()?.querySelector?.('#root > main > .navigation-bar-container') as HTMLElement);
  if (element) {
    const elementDim = element.getBoundingClientRect();
    const elementSticky =
      (documentService()?.querySelector?.('#root > header > .header > #sticky-top-wrapper > .navigation-bar-mobile') as HTMLElement) ||
      (documentService()?.querySelector?.('#root > header > .header > #sticky-top-wrapper > .navigation-bar-container') as HTMLElement);
    const stickyWrapperHeight = stickyWrapperEle?.getBoundingClientRect().height || 0;

    // scrolling up
    if (bodyScrollPosition > scrollPosition) {
      handleScrollUp(elementDim, elementSticky, stickyWrapperHeight, header);
    } else {
      handleScrollDown(elementDim, elementSticky, stickyWrapperHeight, header);
    }
  }

  scrollPosition = bodyScrollPosition;
  return scrollPosition;
};

export { detectScrollDirectionForNavigationBar };
